import { buildEnumMapProvider } from 'sc-common';
import { ApiReviewReportStateEnum } from 'sc-common/core/services/open-api/main-api-client';

export const reviewReportEnumMapProvider = buildEnumMapProvider(ApiReviewReportStateEnum, getEnumText);

export function getEnumText(value: ApiReviewReportStateEnum): string {

    switch (value) {

        case ApiReviewReportStateEnum.Approved:
            return $localize`Approved`;

        case ApiReviewReportStateEnum.NeedToApprove:
            return $localize`Need to approve`;

        case ApiReviewReportStateEnum.None:
            return '';
    }
}
